<template>
  <v-container fluid>
    <v-toolbar>
      <v-toolbar-title>
        {{ $t('COMPANIES.COMPANIES_MANAGEMENT') }}
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn
        dark
        color="indigo"
        @click="$router.push({ name: 'companies.create' })"
      >
        <v-icon left>mdi-plus</v-icon>
        {{ $t('ITEM.NEW') }} {{ $t('COMPANIES.ITEM') }}
      </v-btn>
    </v-toolbar>

    <v-sheet class="mt-5 pa-5" tile>
      <companies-list-filter @setFilters="setFilters" />

      <companies-list
        :meta="meta"
        :items="items"
        :options.sync="options"
      ></companies-list>

      <companies-export :options="filters"></companies-export>
    </v-sheet>
  </v-container>
</template>

<script>
import CompaniesList from './../components/CompanyList';
import CompaniesListFilter from './../components/CompaniesListFilter';
import { mapActions, mapState } from 'vuex';
import CompaniesExport from '@/modules/companies/components/CompaniesExport';
import listOptions from '@/modules/_global/mixins/list-options';

export default {
  name: 'CompaniesPage',

  components: {
    CompaniesExport,
    CompaniesList,
    CompaniesListFilter
  },

  mixins: [listOptions],

  data() {
    return {};
  },

  computed: {
    ...mapState('company', ['paginationOptions'])
  },

  methods: {
    ...mapActions('company', ['getItemsList'])
  }
};
</script>

<style scoped></style>
